"use client";
import Image from "next/image";
import React from "react";

export default function Options(props) {
  const options = props.data.data;
  return (
    <div className="section-wrapper">
      <span className="section-title">Floor Scrubber Popular Options</span>
      <div className="two-columns-wrapper">
        {options.map((option) => (
          <div className="option options" key={option.id}>
            <div>
              <Image
                src={option.attributes.image.data.attributes.url}
                height={1920}
                width={1080}
                alt={
                  option.attributes.image.data.attributes.alternativeText ||
                  `FactoryCat Floor Scrubber - ${option.attributes.title} `
                }
              />
            </div>
            <div>
              <h3>{option.attributes.title}</h3>
              <p>{option.attributes.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
